(function() {
    function getFintelCookie() {
        var fintelCookie = document.cookie
            .split('; ')
            .find(function(row) {
                return row.startsWith('guardtreefc=');
            });
        if (fintelCookie) {
            return fintelCookie.split('=')[1];
        }
    }

    function addFintelCartAttribute(fintelTag) {
        if (fintelTag) {
            var attribute = "attributes[FintelTag]=" + fintelTag;
            return $.ajax({
                type: "POST",
                url: "/cart/update.js",
                data: attribute,
                dataType: "json"});
        }
    }

    $(function() {
        var fintelCookie = getFintelCookie();
        addFintelCartAttribute(fintelCookie);
    });
})();